
import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, User, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '@/routes-map';

interface PatientHeaderProps {
  title?: string;
  showBackButton?: boolean;
  icon?: React.ReactNode;
}

const PatientHeader: React.FC<PatientHeaderProps> = ({
  title,
  showBackButton = true,
  icon
}) => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  
  return (
    <header className="fixed top-0 left-0 right-0 bg-background/95 backdrop-blur-sm z-50 shadow-sm">
      <div className="container mx-auto px-4 py-3 flex items-center">
        <div className="flex items-center flex-1">
          {showBackButton && (
            <button 
              onClick={goBack} 
              className="mr-2 p-1 rounded-full hover:bg-muted transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
          )}
          
          {icon && <div className="mr-2">{icon}</div>}
          
          {title && <h1 className="text-lg font-semibold">{title}</h1>}
        </div>
        
        <div className="flex items-center gap-3">
          <Link to={ROUTES.PATIENT.NOTIFICATIONS} className="p-1 rounded-full hover:bg-muted">
            <Bell className="h-5 w-5" />
          </Link>
          <Link to={ROUTES.PATIENT.PROFILE} className="p-1 rounded-full hover:bg-muted">
            <User className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PatientHeader;
